var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',[_c('the-popup'),_c('the-ato-snackbar'),_c('the-app-bar'),_c('the-side-navigation'),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }